var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"\n    py-2 px-4\n    text-sm text-gray-800 dark:text-gray-400\n    border border-gray-400 dark:border-gray-700\n    hover:bg-gray-300 dark-hover:bg-gray-800\n    focus:outline-none rounded\n  ",class:{
    'bg-gray-300 dark:bg-gray-800': _vm.selected,
    'bg-white dark:bg-gray-900': !_vm.selected
  }},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }